import React, { useEffect, useRef, useState } from 'react';
import GoogleMapReact from 'google-map-react';
import { PingBlueMap } from 'app-principal-componentes-visuales';
import { GOOGLE_MAPS_API_KEY } from '../../utils/constants';
import { direccionGeocode } from '../../helpers/googleApi';
import { debounce } from '../../utils/debounce';

const Marker = ({ lat, lng }) => <><PingBlueMap/></>;

const Mapa = ({defaultCoords, setDireccionGeo, setLoadingDireccion, setCoords, height}: {[ key: string ]: any }) => {
    const {coords} = defaultCoords;
    const {latitude, longitude, zoom} = coords;
    const [loaded, setLoaded] = useState(false);
    const [marker, setMarker] = useState(null);
    let key = GOOGLE_MAPS_API_KEY();

    let defaultProps = {
        center: {
            lat: parseFloat(latitude),
            lng: parseFloat(longitude)
        },
        zoom: parseFloat(zoom || 18)
    };

    useEffect(() => {
        setMarker(defaultProps);
        debouncedGeocode(latitude, longitude);
        setTimeout(() => {   
            setLoaded(true);
        }, 200);
        return () =>{
            setLoaded(false);
        }
    }, [latitude, longitude])

    // Función con debounce: evita llamar a la API en cada movimiento pequeño
    const debouncedGeocode = useRef(
        debounce((lat, long) => {
            setLoadingDireccion(true)
            direccionGeocode(lat, long)
                .then(direccion => {
                    setDireccionGeo(direccion);
                })
                .catch(e =>  {
                    console.error("⚠️ Error al obtener dirección del mapa de geolocalización:", e);
                    setDireccionGeo(null);
                })
                .finally(()=> setLoadingDireccion(false))
        }, 600)
    ).current;

    const onClick = ({lat, lng}) => {
        const center = {lat,lng}
        setMarker({...marker, center })
        debouncedGeocode(lat, lng)
        setCoords(stateCoords => ({...stateCoords,
            latitude: lat,
            longitude: lng
        }))
    }

    const onChange = ({zoom}) => {
        setCoords(stateCoords => {
            return {...stateCoords, zoom}
        })
    }

    return (
        <>
            { loaded &&
                <>
                    <div 
                        style={{ 
                            height: height ?? "55vh", 
                        }} 
                        className='GoogleMapReactWrapper'
                    >
                        <GoogleMapReact 
                            bootstrapURLKeys={{ key: key}}
                            defaultCenter={marker.center}
                            defaultZoom={marker.zoom}
                            onClick={onClick}
                            onChange={onChange}
                            options={{
                                fullscreenControl: false
                            }}
                        >
                            <Marker lat={marker.center.lat} lng={marker.center.lng}/>
                        </GoogleMapReact>
                    </div>
                </>
            }
        </>
    )
}

export default Mapa